import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from '@unform/web';
import { FiUserPlus, FiSearch, FiTrash2, FiEdit } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

import { show } from 'store/modules/dialog/actions';
import api from 'services/api';

import { toast } from 'react-toastify';
import Card from 'components/Card';
import Button from 'components/Button';
import Pagination from 'components/Pagination';
import Input from 'components/Input';
import Flag from 'components/Flag';
import UsuariosLoader from 'components/ContentLoader/UsuariosLoader';
import Avatar from 'components/Avatar';

import { Container, Table, Align } from './styles';
import { Scroll } from 'styles/global';
import { usePermit } from 'utils/hooks/usePermit';
import { Permissao } from 'utils/variables';

export default function Usuarios() {
  // react-router-dom
  const navigate = useNavigate();

  // variaveis
  const [usuarios, setUsuarios] = useState([]);
  const [filtro, setFiltro] = useState({ filtro: null, page: 1 });
  const [selected, setSelected] = useState(null);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  // redux
  const dispatch = useDispatch();
  const { callback: callbackDialog } = useSelector(state => state.dialog);

  const hasUsuarioEditor = usePermit([], [Permissao.USUARIOEDITOR]);

  // verifica se callback foi realizado com sucesso para então remover item da lista
  useEffect(() => {
    if (callbackDialog && callbackDialog.success)
      if (callbackDialog.success.action === 'success' && selected) {
        setUsuarios(prevState =>
          prevState.map(usu =>
            usu.id === selected.id ? { ...usu, status: 'inativo' } : { ...usu },
          ),
        );
      }
  }, [callbackDialog, selected]);

  // effect
  useEffect(() => {
    const controller = new AbortController();
    async function loadUsuarios() {
      setLoading(true);
      await api
        .get('/usuarios', {
          signal: controller.signal,
          params: { nome: filtro.filtro, page: filtro.page },
        })
        .then(response => {
          if (response && response.data) {
            setUsuarios(response.data.docs);
            setPages(response.data.pages);
          }
        })
        .catch(error => {
          if (error instanceof Error) {
            toast.error(error.message);
          } else console.log(error);
        });
      setLoading(false);
    }
    loadUsuarios();
    return () => {
      controller.abort();
    };
  }, [filtro]);

  function handleDelete(usu) {
    setSelected(usu);
    const optionBase = {
      type: 'question',
      text: `Remover ${usu.nome} ?`,
      confirmButtonText: 'CONFIRMAR',
      callback: {
        url: `/usuarios/${usu.id}`,
        method: api.put,
        data: { status: 'inativo', email: usu.email, login: usu.login },
      },
      haveCallback: true,
      successMessage: 'Usuario removido!',
      cancelButtonText: 'NÃO',
      showCancelButton: false,
      showConfirmButton: true,
      showCloseButton: true,
    };
    dispatch(show(optionBase));
  }

  // function handleEdit(usu) {
  //   navigate(`/usuarios/${usu.id}`);
  // }

  // const handleNovoUsuario = useCallback(() => {
  //   navigate('/usuarios/novo');
  // }, []);

  return (
    <Container>
      <header>
        <Button color="primary" onClick={() => navigate('/usuarios/novo')}>
          NOVO USUARIO <FiUserPlus />
        </Button>
      </header>
      <Card margin="10px 10px 0 0">
        <header>
          <h4>LISTA DE USUARIOS</h4>
          <Pagination
            total={pages}
            activePage={filtro.page}
            onClick={page => setFiltro({ ...filtro, page })}
          />
          <div>
            <Form onSubmit={e => setFiltro({ filtro: e.searchLocal, page: 1 })}>
              <Input
                name="searchLocal"
                placeholder="Buscar na Tabela"
                icon={<FiSearch />}
              />
            </Form>
          </div>
        </header>
        {!loading && (
          <Scroll>
            <Table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>NOME</th>
                  <th>LOGIN</th>
                  <th>EMAIL</th>
                  <th>PERMISSÃO</th>
                  <th>STATUS</th>
                  <th>
                    <Align $align="right">AÇÕES</Align>
                  </th>
                </tr>
              </thead>
              <tbody>
                {usuarios &&
                  usuarios.map(usu => (
                    <tr key={usu.id}>
                      <td>
                        <Avatar
                          size="40"
                          name={usu.nome}
                          src={usu.avatar_url}
                          round
                        />
                      </td>
                      <td>{usu.nome}</td>
                      <td>{usu.login}</td>
                      <td>{usu.email}</td>
                      <td>{usu.role}</td>
                      <td>
                        <Flag name={usu.status} type={usu.status} />
                      </td>
                      <td>
                        <Align $align="right">
                          <Button
                            fill
                            color="font"
                            round="true"
                            onClick={() => navigate(`/usuarios/${usu.id}`)}
                            disabled={!hasUsuarioEditor}
                          >
                            <FiEdit />
                          </Button>
                          <Button
                            fill
                            color="font"
                            round="true"
                            disabled={
                              usu.status === 'inativo' || !hasUsuarioEditor
                            }
                            onClick={() => handleDelete(usu)}
                          >
                            <FiTrash2 />
                          </Button>
                        </Align>
                      </td>
                    </tr>
                  ))}
              </tbody>
              <tbody />
            </Table>
          </Scroll>
        )}

        {loading && <UsuariosLoader />}
      </Card>
    </Container>
  );
}
